var video_viewer_default = {
  "video_player": "R3ERu",
  "videoOverlay": "t-X7u",
  "video_container": "iRJ2Z"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
